import { FC, ReactNode } from 'react';
import GenericDropdown from '../../../../ui/GenericDropDown';
import { cn } from '../../../../../utilities/cn';
import {
  formDropdownClassName,
  formDropdownFullBleedButtonClassName,
  formDropdownFullBleedClassName,
  formDropdownMenuClassName,
  formDropdownWidthClassName,
} from '../templateManagement.constants';

export type TemplateFormDropdownOption = {
  id: string;
  label: string;
};

const TemplateFormDropdown: FC<{
  options: TemplateFormDropdownOption[];
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  searchBar?: boolean;
  className?: string;
  dropdownClassName?: string;
  tooltip?: string;
  /** Wrapper width; defaults to capped form width. Use `formDropdownFullBleedClassName` in grids. */
  widthClassName?: string;
  renderOption?: (option: TemplateFormDropdownOption) => ReactNode;
  renderLabel?: (option: TemplateFormDropdownOption | null) => ReactNode;
}> = ({
  options,
  value,
  onChange,
  placeholder,
  searchBar = false,
  className,
  dropdownClassName,
  tooltip,
  widthClassName = formDropdownWidthClassName,
  renderOption,
  renderLabel,
}) => {
  const selected = options.find((option) => option.id === value) ?? null;
  const isFullBleed = widthClassName === formDropdownFullBleedClassName;
  const label =
    renderLabel?.(selected) ?? selected?.label ?? placeholder;

  return (
    <div className={widthClassName}>
      <GenericDropdown
        data={options}
        selected={selected}
        setSelected={(option) => onChange(option.id)}
        getDisplayValue={(option) => option.label}
        getDisplayNode={renderOption}
        label={label}
        tooltip={tooltip}
        searchBar={searchBar}
        truncateLabel={!renderLabel}
        fullWidth
        className={cn(
          isFullBleed ? formDropdownFullBleedButtonClassName : formDropdownClassName,
          className,
        )}
        dropdownClassName={cn(formDropdownMenuClassName, dropdownClassName)}
      />
    </div>
  );
};

export default TemplateFormDropdown;
